// src/ChatDialog.js
import React, { useState, useEffect } from 'react'; // Importer useEffect
import MessageList from './MessageList';
import MessageInput from './MessageInput';
import { db } from './firebase'; // Importer db-instansen fra firebase.js
import {
  collection,
  addDoc,
  query,
  orderBy,
  onSnapshot,
  serverTimestamp // For server-genererte tidspunkt
} from 'firebase/firestore';

function ChatDialog() {
  const [messages, setMessages] = useState([]); // Start med en tom liste, data hentes fra Firestore
  const [currentUser, setCurrentUser] = useState('kunde');

  // 1. Hente meldinger fra Firestore og lytte på oppdateringer
  useEffect(() => {
    // Lag en referanse til 'messages'-collection i Firestore
    const messagesCollectionRef = collection(db, 'messages');

    // Lag en query for å hente meldinger, sortert etter tidspunkt
    const q = query(messagesCollectionRef, orderBy('timestamp', 'asc')); // 'asc' for stigende (eldst først)

    // Sett opp en sanntidslytter (onSnapshot)
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const msgs = [];
      querySnapshot.forEach((doc) => {
        // Legg til id fra dokumentet og dataene
        msgs.push({ id: doc.id, ...doc.data() });
      });
      setMessages(msgs); // Oppdater lokal state med meldinger fra Firestore
    });

    // Opprydningsfunksjon: Fjern lytteren når komponenten "unmounts"
    return () => unsubscribe();
  }, []); // Tom dependency array betyr at denne useEffect kjører kun én gang (ved mount)

  // 2. Sende (lagre) nye meldinger til Firestore
  const handleSendMessage = async (text, sender) => {
    if (text.trim() === '') return;

    const messagesCollectionRef = collection(db, 'messages');
    try {
      await addDoc(messagesCollectionRef, {
        text: text,
        sender: sender,
        timestamp: serverTimestamp() // Bruk serverTimestamp for nøyaktig tid
      });
      // Ikke nødvendig å kalle setMessages her, onSnapshot vil fange opp endringen
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  const toggleUser = () => {
    setCurrentUser(currentUser === 'kunde' ? 'selger' : 'kunde');
  };

  return (
    <div className="chat-dialog">
      <h2>Chat (med Firestore!)</h2>
      <button onClick={toggleUser} style={{ marginBottom: '10px' }}>
        Bytt til {currentUser === 'kunde' ? 'Selger' : 'Kunde'}
      </button>
      <p>Du skriver nå som: <strong>{currentUser}</strong></p>

      <MessageList messages={messages} />
      <MessageInput onSendMessage={handleSendMessage} currentUser={currentUser} />
    </div>
  );
}

export default ChatDialog;